import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { deleteInstance } from 'src/api/extensions';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

interface IDeleteInstanceParams {
  brandId: string;
  extensionId: string;
  instanceId: string;
  instanceName: string;
}

export const useDeleteInstance = (onSuccess?: () => void) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ brandId, extensionId, instanceId }: IDeleteInstanceParams) =>
      deleteInstance(brandId, extensionId, instanceId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.EXTENSIONS, variables.brandId] });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: `${variables.instanceName} has been deleted.`,
      });
      onSuccess?.();
    },
    onError: (error: Error, variables) => {
      showSnackbar({
        message: error.message || `Unable to delete ${variables.instanceName}`,
        status: SnackbarStatus.ERROR,
      });
      captureException(error);
    },
  });
};
